<template>
  <div class="headerWrap" :style="contentStyle">
      <div class="headerWrap-left">
        
        <img  v-if="showBack" :src="src" alt="" @click="$router.go(-1)"/>
      </div>
      
      <span class="headerWrap-title" :style="textStyle">{{title}}</span>
      <div class="headerWrap-right">
        <slot name="right"></slot>
      </div>
      
  </div>
</template>

<script>
import left_black from '../assets/img/icon/left.png'
import left_white from '../assets/img/icon/left_white.png'
export default {
  props: {
    title: String,
    showBack: {
      type:Boolean,
      value:true
    },
    color:String
  },
  data(){
    return {
      src:left_black,
      textStyle:'',
      contentStyle:'background:#fff;'
    }
  },
  created(){
    if( this.color === 'white'){
      this.src= left_white
      this.textStyle = 'color:#fff'
      this.contentStyle = ''
    }
   
    console.log(this.showBack)
  },
  methods: {
            
  }
}
</script>

<style  lang="scss" scoped>

.headerWrap{
 @include flex($cross:center,$main:space-between);
 
  padding: 31px 40px 27px;
  // &:after {
  //   display: block;
  //   content: "";
  // }
  img {
    height: 32px;
    width:32px;
    
  }
  &-left{
    flex: .5;
  }
  &-title{
    flex:1;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    color: #000;
  }
  &-right{
    text-align: right;  
    font-size:28px;
        flex: .5;
  }
}
</style>